module.exports = __webpack_public_path__ + "media/images/athletes/4328-4ce94e73800e2dd472ff2e0e0c9b3568.png";